export const CONTROL = 'control';
export const EXPERIMENT = 'experiment';

export const JF_VERTICAL_STACK = 'experiment-jf-vertical-stack';

export const EXPERIMENT_JF_HIDE_PAGINATION = 'experiment-jf-hide-pagination';

// Upcycle gift kit modal experiment
export const EXPERIMENT_UPCYCLE_MODAL_ADD_GIFT_KIT =
  'upcycle-modal-add-gift-kit';
export const prepKitAmplitudeVariantName = 'automatic 2mo reminder';
export const prepKitAmplitudeControlName = 'control';

// Stripe Link Payment Method Config Experiment
export const STRIPE_LINK_EXPERIMENT = 'experiment-jf-link';

// Trial Authorization Hold Experiment
export const EXPERIMENT_JF_TRIAL_AUTHORIZATION_HOLD =
  'experiment-trial-auth-hold';
export const EXPERIMENT_JF_TRIAL_AUTHORIZATION_HOLD_TEXT =
  'experiment-trial-test-hold-disclaimer';
export const JF_TRIAL_AUTHORIZATION_HOLD_VARIANT = 'experiment';

export const EXPERIMENT_JF_BNPL_EXPOSURE_V2 = 'experiment-jf-bnpl-exposure-v2';

export const EXPERIMENT_WEB_JF_BAND_PAGE_M2 =
  'experiment-web-jf-band-page-v2-m2';

export const BNPL_CONTROL = 'control';
export const BNPL_EXPERIMENT = 'experiment';

export const EXPERIMENT_UPCYCLE_TIER_GIFT_MEMBERSHIPS =
  'experiment-upcycle-tier-gift-memberships';

export const EXPERIMENT_UPCYCLE_TIER_GIFT_MEMBERSHIPS_VARIANTS = {
  control: 'control',
  both: 'both',
  one: 'one',
} as const;

export const EXPERIMENT_LAZY_LOAD = 'experiment-jf-lazy-load';

export const EXPERIMENT_JF_HSA_FSA_MESSAGING =
  'experiment-jf-hsa-fsa-messaging';
export const HSA_FSA_PLAN_CARDS_VARIANT = 'plan-cards';
export const HSA_FSA_TAGS_VARIANT = 'tags';

export const EXPERIMENT_JF_PERSISTENT_CART = 'experiment-jf-persistent-cart-v2';

export const EXPERIMENT_STYLE_CONSISTENCY = 'style-consistency-v1';

export const EXPERIMENT_JF_SKIP_MEM_SELECT_TRANSITION =
  'experiment-jf-skip-mem-select-transition';
